import { render } from "./Categories.vue?vue&type=template&id=24a1fe64"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/utmtco-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__